import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import "./ProjectList.css";
// api
import { projectLists, projectDelete,  } from "../../api/project/projectApi";
import { projectInfo } from "../../api/project/projectApi"; // ✅ 상세조회 API
import { detectdownload } from "../../api/aidetect/detectApi";
import CircularProgress from "@mui/material/CircularProgress";
import close_icon from "../../Images/utilImages/close_icon.png";
import info_icon from "../../Images/utilImages/info_icon.png";
import download_icon from "../../Images/utilImages/download_icon.png";
import delete_icon from "../../Images/utilImages/delete_icon.png";
import edit_icon from "../../Images/utilImages/edit_icon.png";
import more_icon from "../../Images/utilImages/more_icon.png";
import { useProject, detectresult } from "../../ProjectContext";



// mui 
import Tooltip from '@mui/material/Tooltip';
import EditProject from "../Popup/EditProject/EditProject";

const ProjectDataList = () => {
  const { t } = useTranslation('menubar');
  const { projectInfo: projectCtx, setProjectInfo } = useProject();
  const {groupId, projectId, fileId } = projectCtx;
  const [selectedProjectId, setSelectedProjectId] = useState(projectCtx.projectId || null);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingIds, setDeletingIds] = useState([]); // 삭제 중 ID 관리
  const [isEditOpen, setIsEditOpen] = useState(false); // ✅ 수정 팝업 상태
  const [editTarget, setEditTarget] = useState(null); // ✅ 어떤 프로젝트를 수정 중인지
  
  // ✅ 데이터 목록 불러오기
  const fetchDataList = async () => {
    setLoading(true);
    try {
      const res = await projectLists(groupId);
      if (res && Array.isArray(res.data)) {
        setDataList(res.data);
      } else {
        console.warn("예상치 못한 데이터 구조:", res);
        setDataList([]);
      }
    } catch (error) {
      console.error("데이터 목록 불러오기 실패:", error);
      setDataList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataList();
  }, [groupId]);

  // ✅ 프로젝트 클릭 시
  // ✅ 프로젝트 클릭 시 Context에 저장 + 상세 조회
  const handleSelectProject = async (projectId) => {
    try {
      setSelectedProjectId(projectId);

      // 프로젝트 상세정보 조회
      const info = await projectInfo(projectId);

      let imageId = null;
      if (info && Array.isArray(info.data) && info.data.length > 0) {
        imageId = info.data[0].projectImageId;
      }

      // Context에 저장
      setProjectInfo((prev) => ({
        ...prev,
        projectId: projectId,
        fileId: imageId,
      }));

      // console.log("✅ Context 저장 완료:", {
      //   projectId,
      //   projectImageId: imageId,
      // });
    } catch (error) {
      console.error("프로젝트 상세 조회 실패:", error);
      alert("프로젝트 상세 정보를 불러오지 못했습니다.");
    }
  };

  // ✅ 다운로드 핸들러 함수
  const handleDownload = async (e, item) => {
    e.stopPropagation();
    try {
      if (!groupId || !projectId || !fileId) {
        const missing = [];
        if (!groupId) missing.push("groupId");
        if (!projectId) missing.push("projectId");
        if (!fileId) missing.push("fileId");
        alert(`⚠️ 프로젝트 정보가 부족합니다.\n누락된 값: ${missing.join(", ")}`);
        console.warn("❌ 누락된 값:", { groupId, projectId, fileId });
        return;
      }

      console.log("📦 다운로드 시작:", { groupId, projectId, fileId});

      const res = await detectdownload(groupId, projectId, fileId);

      // ✅ Blob 다운로드 처리
      const blob = new Blob([res.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${item.projectName || "orthophoto"}.tif`;
      a.click();

      window.URL.revokeObjectURL(url);
      console.log("✅ 다운로드 완료:", a.download);
    } catch (err) {
      console.error("❌ 다운로드 실패:", err);
      alert("다운로드 중 오류가 발생했습니다.");
    }
  };

 // ✅ 수정 버튼 클릭 시
 const handleEditClick = (e, item) => {
  e.stopPropagation();
  setEditTarget(item);  // 수정할 프로젝트 데이터 저장
  setIsEditOpen(true);  // 팝업 열기
};

const handleCloseEdit = () => {
  setIsEditOpen(false);
  setEditTarget(null);
};

  // ✅ 삭제 핸들러
  const handleDelete = async (e, item) => {
    if (!window.confirm("정말로 삭제하시겠습니까?")) return;

    try {
      setDeletingIds((prev) => [...prev, projectId]);
      await projectDelete(projectId);
      await fetchDataList(); // 최신 데이터 반영
    } catch (error) {
      console.error("프로젝트 삭제 실패:", error);
      alert("삭제 중 오류가 발생했습니다.");
    } finally {
      setDeletingIds((prev) => prev.filter((id) => id !== projectId));
    }
  };

  if (loading) {
    return (
      <div className="DataList_Loading">
        <CircularProgress size={20} /> 불러오는 중...
      </div>
    );
  }

  if (dataList.length === 0) {
    return <div className="DataList_Empty">등록된 데이터가 없습니다.</div>;
  }

  return (
    <div className="DataList_Container">
      {dataList.map((item) => {
        const isSelected = selectedProjectId === item.projectId;
        
        return (
          <div key={item.projectId} className={`DataList_Item ${isSelected ? "active" : "" }`} onClick={()=> handleSelectProject(item.projectId)}
            style=
            {{
                  overflow: "hidden",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
            >
            <div className="DataList_Name">
              <div>
                {item.projectName}
              </div>
              <div>
                <img src={more_icon} className="icon" />
              </div>
            </div>

            {/* 선택된 경우 아래로 확장 */}
            {isSelected && (
            <div className="DataList_Expand">
              {/* 상세보기 버튼 */}
              <Tooltip title={t("project.info")}>
                <div className="btn_box">
                  <div>
                    <img src={info_icon} className="icon" />
                  </div>
                  <div>
                    <div className="DataList_Expand button download" onClick={(e)=> {
                      e.stopPropagation();
                      console.log("프로젝트 상세정보 클릭:", item.projectId);
                      // handleDownload(item.projectId)
                      }}
                      >
                    </div>
                  </div>
                </div>
              </Tooltip>

              {/* 다운로드 버튼 */}
              <Tooltip title={t("project.down")}>
                <div className="btn_box" onClick={(e)=> handleDownload(e, item)}>
                  <div>
                    <img src={download_icon} className="icon" />
                  </div>
                  <div>
                    <div className="DataList_Expand button download" onClick={(e)=> {
                      e.stopPropagation();
                      console.log("다운로드 클릭:", item.projectId);
                      // handleDownload(item.projectId)
                      }}
                      >
                    </div>
                  </div>
                </div>
              </Tooltip>

              {/* 수정 버튼 */}
              <Tooltip title={t("project.edit")}>
                  <div className="btn_box" onClick={(e) => handleEditClick(e, item)}>
                    <div><img src={edit_icon} className="icon" /></div>
                  </div>
                </Tooltip>

              {/* 삭제 버튼 */}
              <Tooltip title={t("project.delete")}>
                <div className="btn_box" onClick={(e)=> handleDelete(e, item)}>
                  <div>
                    <img src={delete_icon} className="icon" />
                  </div>
                  <div>
                    <div className="DataList_Expand button download" onClick={(e)=> {
                      e.stopPropagation();
                      console.log("프로젝트 삭제 클릭:", item.projectId);
                      // handleDownload(item.projectId)
                      }}
                      >
                    </div>
                  </div>
                </div>
              </Tooltip>
            </div>
            )}
          </div>
          );
        })}

       {/* ✅ 수정 팝업 */}
      {isEditOpen && (
        <div className="PopupContainer">
        <EditProject
          open={isEditOpen}
          onClose={() => setIsEditOpen(false)}
          project={editTarget}
          refreshList={fetchDataList}
        />
        </div>
      )}

    </div>
  );
};

export default ProjectDataList;

